import { HardwareService } from "../../HardwareService";
import { type Peripheral } from "../Peripheral";
import { type PeripheralSearchConfig, type PeripheralSearchResponse } from "../types";
import { PeripheralService } from "../PeripheralService";
import { webviewAppBridge } from "./WebviewAppBridge";
import { webviewNamespace } from "./constants";
import { WebviewAppPeripheralData } from "./types";

export abstract class WebviewAppPeripheralService<
  T extends Peripheral
> extends PeripheralService<T> {
  abstract createDevice(info: WebviewAppPeripheralData): T;

  get isSupported(): boolean {
    return Boolean((window as any)[webviewNamespace]);
  }

  protected async availableDevices(): Promise<T[]> {
    return [];
  }

  override async search(
    config?: Partial<PeripheralSearchConfig>
  ): Promise<PeripheralSearchResponse<T>> {
    try {
      const results = await webviewAppBridge.search(
        this.peripheralType,
        config
      );
      const devices = results.map((result) => this.createDevice(result));

      return {
        devices,
        newDevices: [],
      };
    } catch (error) {
      HardwareService.logger.e(
        `Failed searching for webview ${this.typeName}`,
        error
      );
    }
    return {
      devices: [],
      newDevices: [],
    };
  }

  override async waitUntilReady(): Promise<boolean> {
    const result = await webviewAppBridge.waitUntilReady(this.typeName);
    if (result) {
      webviewAppBridge.sync(this.peripheralType);
    }
    return result;
  }
}
